import { AnyAction } from 'redux';
import produce, { Draft } from 'immer';
import { V3FeatureFlagTask } from '../../types';
import { ACTION_NAMES } from '../../constants';

type V3FeatureFlagSliceInRedux = {
  featureFlags: Record<string, boolean>;
  crewId?: number;
  userId?: number;
};

type V3FeatureFlagAction = {
  result: V3FeatureFlagTask;
  crewId?: number;
  userId?: number;
};

const initialState = { featureFlags: {}, crewId: undefined, userId: undefined } as V3FeatureFlagSliceInRedux;

export const v3FeatureFlagReducer = (
  state = initialState,
  action: AnyAction & V3FeatureFlagAction
): V3FeatureFlagSliceInRedux =>
  produce(state, (draft: Draft<V3FeatureFlagSliceInRedux>) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_LOAD_FEATURE_FLAGS}_SUCCESS`:
        // Replace feature flags entirely instead of merging to ensure crew-specific flags are loaded
        // eslint-disable-next-line no-param-reassign
        draft.featureFlags = action.result.resourceAfterWrite.output.featureFlags ?? {};
        // eslint-disable-next-line no-param-reassign
        draft.crewId = action.crewId;
        // eslint-disable-next-line no-param-reassign
        draft.userId = action.userId;
        break;
      case 'CREW_CHANGED':
        // Clear all feature flags when crew changes to force complete reload
        // eslint-disable-next-line no-param-reassign
        draft.featureFlags = {};
        // eslint-disable-next-line no-param-reassign
        draft.crewId = undefined;
        // eslint-disable-next-line no-param-reassign
        draft.userId = undefined;
        break;
      default:
      // nothing to do => immer returns the original object
    }
  });
